import paymentLogo1 from "../../assets/images/plan/pyment-logo-1.png";
import paymentLogo2 from "../../assets/images/plan/pyment-logo-2.png";
import paymentLogo3 from "../../assets/images/plan/pyment-logo-3.png";
import paymentLogo4 from "../../assets/images/plan/pyment-logo-4.png";
import paymentLogo5 from "../../assets/images/plan/pyment-logo-5.png";
import paymentLogo6 from "../../assets/images/plan/pyment-logo-6.png";

export default function PaymentLogosSection() {
  return (
    <section className="contanier payment-section">

      <div className=" payment-logos">

        <img src={paymentLogo1} alt="logo payment" />
        <img src={paymentLogo2} alt="logo payment" />
       <img src={paymentLogo3} alt="logo payment" />
       <img src={paymentLogo4} alt="logo payment" />
        <img src={paymentLogo5} alt="logo payment" />
       <img src={paymentLogo6} alt="logo payment" />

      </div>
    </section>
  );
}